import config from '@epi-config';

const HIGH_PRECISION_DECIMALS = 6;
const STANDARD_PRECISION_DECIMALS = 2;

export const isHighPrecisionEnabled = (): boolean => {
  const { highPrecisionStartDate } = config;
  if (!highPrecisionStartDate) return false;
  return new Date() >= new Date(highPrecisionStartDate);
};

export const getVatPrecision = (): number =>
  isHighPrecisionEnabled()
    ? HIGH_PRECISION_DECIMALS
    : STANDARD_PRECISION_DECIMALS;

export const FEE_PRECISION = STANDARD_PRECISION_DECIMALS;
